<app-document-request
  [documentRequest]="documentRequest()"
  (openOrCloseDocumentRequest)="openOrCloseDocumentRequest.emit(documentRequest())"
/>
<div tiimeForm class="document-request-form">
  <div tiimeFormColumn>
    <tiime-input-container label="Titre">
      <input disabled [value]="documentRequest().title" />
    </tiime-input-container>
    <tiime-input-container label="Description">
      <textarea disabled [value]="documentRequest().description" cdkTextareaAutosize cdkAutosizeMinRows="3"></textarea>
    </tiime-input-container>
    <tiime-input-container label="Commentaire">
      <textarea
        disabled
        [value]="documentRequest().comment || ''"
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
      ></textarea>
    </tiime-input-container>
    <div class="customer-documents-container">
      @for (document of documentRequest().documents; track document.id) {
        <div class="customer-document">
          <div class="customer-document__name">
            {{ document.name }}
          </div>
          <div class="customer-document__actions">
            <button
              tiime-button
              strocked
              small
              color="primary"
              icon
              (click)="downloadCustomerDocument.emit(document.id)"
            >
              <mat-icon fontIcon="icon-download-24"></mat-icon>
            </button>
            <button
              tiime-button
              strocked
              small
              color="primary"
              icon
              (click)="openCustomerDocumentInNewTab.emit(document.id)"
            >
              <mat-icon fontIcon="icon-open-in-new-window-2"></mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
    @if (showStockRouterLink()) {
      <a tiime-button raised color="primary" [routerLink]="stockRouterLink()" target="_blank" rel="noopener">
        <mat-icon fontSet="fontastic" fontIcon="icon-open-in-new-window-2" inline />
        Ouvrir les stocks
      </a>
    }
  </div>
</div>
